"use strict";
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * @module auth
 * @description
 */

module.exports = function (config, get, post) {
	/**
	 * Changes the person's email
	 * @param  {Object} data  Contains the new `email` and the `confirm`
	 * @return {Promise}      Resolves if change was successful
	 */
	function email(data) {
		return post("/v2/auth/email", data);
	}

	/**
	 * Changes password
	 * @param  {Object} data  Contains `old` password, new `password`, and `confirm`
	 * @return {Promise}      Resolves to user id if successful
	 */
	function password(data) {
		return post("/v2/auth/password", data);
	}

	/**
	 * Resets your password given a password reset code
	 * @param  {String}  code     Password reset code from the email
	 * @param  {String}  password New password to use
	 * @param  {String}  confirm  Confirm new password
	 * @return {Promise}          Resolves if the password was reset properly
	 */
	password.reset = function (code, password, confirm) {
		return post("/v2/auth/password/reset", {
			code: code,
			password: password,
			confirm: confirm
		});
	};

	/**
	 * Requests for a password reset code which gets sent to the specified email
	 * @param  {String}  email Account email to send to
	 * @return {Promise}       Resolves if the email was sent successfully
	 */
	password.request = function (email) {
		return post("/v2/auth/password/reset/request", {
			email: email
		});
	};

	/**
	 * Authenticates a session token and returns basic user data
	 * @param  {String} token Session token to authenicate, optional
	 * @return {Promise}      Resolves to basic user data
	 */
	function auth(token) {
		return get("/v2/auth/auth", {
			token: token
		});
	}

	/**
	 * Registers a new user
	 * @param  {Object} data  Data to register user with
	 * @return {Promise}      Resolves to object containing user id
	 */
	function register(data) {
		return post("/v2/auth/register", data);
	}

	/**
	 * Validates login credentials and generates a new session token
	 * @param  {String} email    Email to login with
	 * @param  {String} password Password to login with
	 * @return {Promise}         Resolves to object with session token and user id
	 */
	function login(email, password) {
		return post("/v2/auth/login", {
			email: email,
			password: password
		});
	}

	/**
	 * Notifies the server that a user has logged out
	 * @return {Promise}       Resolves to statuscode 200 if operation successful
	 */
	function logout(token) {
		return post("/v2/auth/logout", {token});
	}

	/**
	 * Uses an invitation code and becomes contacts with the sender
	 * @param  {String}  code The invitation code
	 * @return {Promise}      Resolves if code was used successfully
	 */
	function invite_code(code) {
		return post("/v2/auth/code/invite", {
			code: code
		});
	}

	function verify(code) {
		return post("/v2/auth/verify", {
			code: code
		});
	}

	verify.resend = resend_verify;

	function resend_verify() {
		return post("/v2/auth/verify/resend", {});
	}

	/**
	 * Checks if an email has already been registered
	 * @param  {String}  email The email to check
	 * @return {Promise}       Resolves to object with whether the account already `exists`
	 */
	function check(email) {
		return post("/v2/auth/check", {
			email: email
		});
	}

	function twoFactorAuth(id, code) {
		return post("/v2/auth/multi_auth", {
			id: id,
			auth_code: code
		});
	}

	function twoFactorAuthRequest(id, email) {
		return post("/v2/auth/multi_auth/request", {
			id: id,
			email: email
		});
	}

	/**
	 * complete a user account by added email and password
	 * @param  {String} email 	The user email
	 * @param {String}	password	The user password
	 * @param {String}	confirmedpassword	The user password
	 */
	function finishaccount(email, password, confirmedpassword){
		return post("/v2/auth/finishaccount", {
			email: email,
			password: password,
			confirmedpassword
		});
	}

	return {
		email: email,
		auth: auth,
		register: register,
		login: login,
		logout: logout,
		password: password,
		check: check,
		code: {
			invite: invite_code
		},
		verify: verify,
		twoFactorAuth: twoFactorAuth,
		twoFactorAuthRequest: twoFactorAuthRequest,
		finishaccount
	};
};
